import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e91645be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "form container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-xs-12 margin-bottom-form-field"
}
const _hoisted_5 = ["aria-expanded"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "country-dial" }
const _hoisted_8 = {
  key: 0,
  class: "country-dropdown"
}
const _hoisted_9 = { class: "country-search-wrap" }
const _hoisted_10 = { class: "country-options" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "country-option-name" }
const _hoisted_14 = { class: "country-option-dial" }
const _hoisted_15 = {
  key: 0,
  class: "country-empty"
}
const _hoisted_16 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_17 = {
  key: 1,
  class: "col-xs-12 margin-bottom-form-field"
}
const _hoisted_18 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_19 = { class: "row" }
const _hoisted_20 = {
  class: "col-xs-12 margin-bottom-form-field",
  style: {"position":"relative"}
}
const _hoisted_21 = ["type"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "registration-error"
}
const _hoisted_24 = { class: "error-text" }
const _hoisted_25 = { class: "submit" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loginWithPhone)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(`phone-field ${_ctx.errors.username.length ? 'error' : ''}`)
              }, [
                _createElementVNode("div", {
                  class: "country-picker",
                  ref: "countryPickerRef",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "country-trigger",
                    "aria-expanded": _ctx.isCountryDropdownOpen,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCountryDropdown && _ctx.toggleCountryDropdown(...args)))
                  }, [
                    _createElementVNode("img", {
                      class: "country-flag",
                      src: _ctx.selectedCountryFlag,
                      alt: _ctx.selectedCountry.name,
                      width: "24",
                      height: "18"
                    }, null, 8, _hoisted_6),
                    _createElementVNode("span", _hoisted_7, "+" + _toDisplayString(_ctx.selectedCountry.dialCode), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["country-caret", { open: _ctx.isCountryDropdownOpen }])
                    }, null, 2)
                  ], 8, _hoisted_5),
                  (_ctx.isCountryDropdownOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            ref: "countrySearchRef",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.countrySearch) = $event)),
                            class: "country-search",
                            type: "text",
                            inputmode: "search",
                            placeholder: "Pretraži državu...",
                            autocomplete: "off",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.closeCountryDropdown && _ctx.closeCountryDropdown(...args)), ["stop"]), ["esc"]))
                          }, null, 544), [
                            [_vModelText, _ctx.countrySearch]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCountries, (country) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: country.iso2,
                              type: "button",
                              class: _normalizeClass(["country-option", { active: country.iso2 === _ctx.selectedCountryIso2 }]),
                              onClick: ($event: any) => (_ctx.selectCountry(country.iso2))
                            }, [
                              _createElementVNode("img", {
                                class: "country-flag",
                                src: _ctx.getCountryFlagUrl(country.iso2),
                                alt: country.name,
                                width: "24",
                                height: "18"
                              }, null, 8, _hoisted_12),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(country.name), 1),
                              _createElementVNode("span", _hoisted_14, "+" + _toDisplayString(country.dialCode), 1)
                            ], 10, _hoisted_11))
                          }), 128)),
                          (!_ctx.filteredCountries.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Nema rezultata"))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 512),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.phone) = $event)),
                  class: "phone-input",
                  type: "tel",
                  inputmode: "numeric",
                  autocomplete: "tel-national",
                  placeholder: "641234567",
                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onPhoneInput && _ctx.onPhoneInput(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.phone]
                ])
              ], 2),
              (_ctx.errors.username.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.errors.username), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "alt-method-link",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.switchToUsername && _ctx.switchToUsername(...args)))
              }, " Koristi korisničko ime umesto telefona ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.username) = $event)),
                class: _normalizeClass(`tb ${_ctx.errors.username.length ? 'error' : ''}`),
                type: "text",
                placeholder: "Korisničko ime ili email"
              }, null, 2), [
                [_vModelText, _ctx.form.username]
              ]),
              (_ctx.errors.username.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.errors.username), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "alt-method-link",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.switchToPhone && _ctx.switchToPhone(...args)))
              }, " Koristi telefon umesto korisničkog imena ")
            ]))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.password) = $event)),
            class: _normalizeClass(`tb ${_ctx.errors.password.length ? 'error' : ''}`),
            type: _ctx.isVisible ? 'text' : 'password',
            placeholder: "Lozinka"
          }, null, 10, _hoisted_21), [
            [_vModelDynamic, _ctx.form.password]
          ]),
          _createElementVNode("img", {
            src: _ctx.isVisible ? _ctx.eyeIcons.visible : _ctx.eyeIcons.hidden,
            class: "hidden-eye",
            style: _normalizeStyle(_ctx.changePasswordEyeStyle()),
            alt: "",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleVisibility && _ctx.handleVisibility(...args)))
          }, null, 12, _hoisted_22),
          (_ctx.errors.password.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.errors.password), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", {
          class: "forgot-password",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.forgotPassword()))
        }, "Zaboravljena lozinka?")
      ])
    ]),
    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.getLoginErrorMessage), 1),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("button", {
        class: "btnSubmit",
        disabled: _ctx.isLoadingLogin,
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleLogin()))
      }, _toDisplayString(_ctx.isLoadingLogin ? "Učitavanje..." : "Ulogujte se"), 9, _hoisted_26)
    ])
  ]))
}